/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import styles from '../../assessmentPage/Questionnaire/GeneralInfo.module.scss';
import cn from 'classnames';

interface Language {
    language: string;
    level: number | string;
    speaking: string;
    reading: string;
    writing: string;
    listening: string;
}

const initLanguage: Language = {
    language: '',
    level: '',
    speaking: '',
    reading: '',
    writing: '',
    listening: '',
};
interface Entry {
    license_number: string;
    country: string;
    date_issued: Date | null | string;
}

const initEntry: Entry = {
    license_number: '',
    country: '',
    date_issued: '',
};
export default function LicenseInfo() {
    const licenseTableName = 'License';
    const languageTableName = 'Language';

    const [data, setData] = useState<Entry[]>([initEntry]);
    const [langData, setLangData] = useState<Language[]>([initLanguage]);

    useEffect(() => {
        api.tableInput.newFetchCandidateInput(setData, licenseTableName);
        api.tableInput.newFetchCandidateInput(setLangData, languageTableName);
    }, []);

    return (
        <>
            <div>
                {data?.map((item: any, index: number) => (
                    <span key={index}>
                        <h4 className={styles.title}>License N{index + 1}</h4>
                        <div className={` ${cn(styles.box, styles.fullWidth)}`}>
                            <div className={`grid grid-cols-2  gap-x-5`}>
                                <h4>Country</h4>
                                <h4>Date Issued</h4>

                                <p className={styles.value}>{item?.country}</p>
                                <p className={styles.value}> {item?.date_issued}</p>
                            </div>
                            <h4>License Number</h4>
                            <p className={styles.value}> {item?.license_number}</p>
                        </div>
                    </span>
                ))}
                {langData?.map((item: any, index: number) => (
                    <span key={index}>
                        <h4 className={styles.title}>Language N{index + 1}</h4>
                        <div
                            className={`grid grid-cols-2  gap-x-5  ${cn(
                                styles.box,
                                styles.fullWidth
                            )}`}
                        >
                            <h4>Language</h4>
                            <h4>level</h4>
                            <p className={styles.value}>{item?.language}</p>
                            <p className={styles.value}> {item?.level}</p>
                            {/* <h4>Speaking</h4>
                            <h4>Listening</h4>
                            <p className={styles.value}>{item?.speaking}</p>
                            <p className={styles.value}>{item?.listening}</p>
                            <h4>Reading</h4>
                            <h4> Writing </h4>
                            <p className={styles.value}>{item?.reading}</p>
                            <p className={styles.value}>{item?.writing}</p> */}
                        </div>
                    </span>
                ))}
            </div>
        </>
    );
}
